// THIS IS A GENERATED FILE
import * as Types from '@gatsbyjs/graphql/types';

import gql from 'graphql-tag';
import { useApolloFragment } from 'apollo-fragment-react';


export type SiteDetailsBuildsEnabledFieldsFragment = (
  { __typename?: 'Site' }
  & Pick<Types.Site, 'id' | 'buildsEnabled'>
);

export type SiteDetailsBurstModeFragFragment = (
  { __typename?: 'Site' }
  & Pick<Types.Site, 'id' | 'buildsEnabled'>
);

export type SiteDetailsIncrementalDeploysProductionEnabledFieldsFragment = (
  { __typename?: 'Site' }
  & Pick<Types.Site, 'id' | 'incrementalDeploysProductionEnabled'>
);

export type SiteDetailsSlicesApiEnabledFieldsFragment = (
  { __typename?: 'Site' }
  & Pick<Types.Site, 'id' | 'slicesAPIEnabled'>
);

export type SiteDetailsGatsbyjsioEnabledFieldsFragment = (
  { __typename?: 'Site' }
  & Pick<Types.Site, 'id' | 'gatsbyjsioEnabled'>
);

export type SiteDetailsPreviewBuildsEnabledFieldsFragment = (
  { __typename?: 'Site' }
  & Pick<Types.Site, 'id' | 'previewBuildsEnabled' | 'incrementalPreviewsEnabled' | 'incrementalDeploysEnabled'>
);

export type SitePreviewSettingsFieldsFragment = (
  { __typename?: 'Site' }
  & Pick<Types.Site, 'previewBuildsEnabled' | 'incrementalPreviewsEnabled' | 'previewTriggerType' | 'incrementalDeploysEnabled'>
);

export type SiteDetailsManualHostingDeploysEnabledFieldsFragment = (
  { __typename?: 'Site' }
  & Pick<Types.Site, 'id' | 'manualHostingDeploysEnabled'>
);

export type SiteDetailsMerlinPullRequestsSourcingEnabledFieldsFragment = (
  { __typename?: 'Site' }
  & Pick<Types.Site, 'id' | 'merlinPullRequestsSourcingEnabled'>
);

export const SiteDetailsBuildsEnabledFieldsFragmentDoc = gql`
    fragment SiteDetailsBuildsEnabledFields on Site {
  id
  buildsEnabled
}
    `;
export const SiteDetailsBurstModeFragFragmentDoc = gql`
    fragment SiteDetailsBurstModeFrag on Site {
  id
  buildsEnabled
}
    `;
export const SiteDetailsIncrementalDeploysProductionEnabledFieldsFragmentDoc = gql`
    fragment SiteDetailsIncrementalDeploysProductionEnabledFields on Site {
  id
  incrementalDeploysProductionEnabled
}
    `;
export const SiteDetailsSlicesApiEnabledFieldsFragmentDoc = gql`
    fragment SiteDetailsSlicesAPIEnabledFields on Site {
  id
  slicesAPIEnabled
}
    `;
export const SiteDetailsGatsbyjsioEnabledFieldsFragmentDoc = gql`
    fragment SiteDetailsGatsbyjsioEnabledFields on Site {
  id
  gatsbyjsioEnabled
}
    `;
export const SiteDetailsPreviewBuildsEnabledFieldsFragmentDoc = gql`
    fragment SiteDetailsPreviewBuildsEnabledFields on Site {
  id
  previewBuildsEnabled
  incrementalPreviewsEnabled
  incrementalDeploysEnabled
}
    `;
export const SitePreviewSettingsFieldsFragmentDoc = gql`
    fragment SitePreviewSettingsFields on Site {
  previewBuildsEnabled
  incrementalPreviewsEnabled
  previewTriggerType
  incrementalDeploysEnabled
}
    `;
export const SiteDetailsManualHostingDeploysEnabledFieldsFragmentDoc = gql`
    fragment SiteDetailsManualHostingDeploysEnabledFields on Site {
  id
  manualHostingDeploysEnabled
}
    `;
export const SiteDetailsMerlinPullRequestsSourcingEnabledFieldsFragmentDoc = gql`
    fragment SiteDetailsMerlinPullRequestsSourcingEnabledFields on Site {
  id
  merlinPullRequestsSourcingEnabled
}
    `;

  /**
   * __useSiteDetailsBuildsEnabledFieldsFragment__
   * To read a fragment data from Apollo Cache, call `useSiteDetailsBuildsEnabledFieldsFragment` and pass it the ID of the cached object.
   * When your component renders, `useSiteDetailsBuildsEnabledFieldsFragment` returns an object from Apollo Client cache that contains data property
   * you can use to render your UI.
   *
   * @param id a string representing the ID of the cached object that will be passed into the useApolloFragment
   *
   * @example
   * const { data } = useSiteDetailsBuildsEnabledFieldsFragment('fragment-id');
   */
export function useSiteDetailsBuildsEnabledFieldsFragment(id: string) {
          return useApolloFragment<SiteDetailsBuildsEnabledFieldsFragment>(SiteDetailsBuildsEnabledFieldsFragmentDoc, id);
        }
export type SiteDetailsBuildsEnabledFieldsFragmentHookResult = ReturnType<typeof useSiteDetailsBuildsEnabledFieldsFragment>;

  /**
   * __useSiteDetailsBurstModeFragFragment__
   * To read a fragment data from Apollo Cache, call `useSiteDetailsBurstModeFragFragment` and pass it the ID of the cached object.
   * When your component renders, `useSiteDetailsBurstModeFragFragment` returns an object from Apollo Client cache that contains data property
   * you can use to render your UI.
   *
   * @param id a string representing the ID of the cached object that will be passed into the useApolloFragment
   *
   * @example
   * const { data } = useSiteDetailsBurstModeFragFragment('fragment-id');
   */
export function useSiteDetailsBurstModeFragFragment(id: string) {
          return useApolloFragment<SiteDetailsBurstModeFragFragment>(SiteDetailsBurstModeFragFragmentDoc, id);
        }
export type SiteDetailsBurstModeFragFragmentHookResult = ReturnType<typeof useSiteDetailsBurstModeFragFragment>;

  /**
   * __useSiteDetailsIncrementalDeploysProductionEnabledFieldsFragment__
   * To read a fragment data from Apollo Cache, call `useSiteDetailsIncrementalDeploysProductionEnabledFieldsFragment` and pass it the ID of the cached object.
   * When your component renders, `useSiteDetailsIncrementalDeploysProductionEnabledFieldsFragment` returns an object from Apollo Client cache that contains data property
   * you can use to render your UI.
   *
   * @param id a string representing the ID of the cached object that will be passed into the useApolloFragment
   *
   * @example
   * const { data } = useSiteDetailsIncrementalDeploysProductionEnabledFieldsFragment('fragment-id');
   */
export function useSiteDetailsIncrementalDeploysProductionEnabledFieldsFragment(id: string) {
          return useApolloFragment<SiteDetailsIncrementalDeploysProductionEnabledFieldsFragment>(SiteDetailsIncrementalDeploysProductionEnabledFieldsFragmentDoc, id);
        }
export type SiteDetailsIncrementalDeploysProductionEnabledFieldsFragmentHookResult = ReturnType<typeof useSiteDetailsIncrementalDeploysProductionEnabledFieldsFragment>;

  /**
   * __useSiteDetailsSlicesApiEnabledFieldsFragment__
   * To read a fragment data from Apollo Cache, call `useSiteDetailsSlicesApiEnabledFieldsFragment` and pass it the ID of the cached object.
   * When your component renders, `useSiteDetailsSlicesApiEnabledFieldsFragment` returns an object from Apollo Client cache that contains data property
   * you can use to render your UI.
   *
   * @param id a string representing the ID of the cached object that will be passed into the useApolloFragment
   *
   * @example
   * const { data } = useSiteDetailsSlicesApiEnabledFieldsFragment('fragment-id');
   */
export function useSiteDetailsSlicesApiEnabledFieldsFragment(id: string) {
          return useApolloFragment<SiteDetailsSlicesApiEnabledFieldsFragment>(SiteDetailsSlicesApiEnabledFieldsFragmentDoc, id);
        }
export type SiteDetailsSlicesApiEnabledFieldsFragmentHookResult = ReturnType<typeof useSiteDetailsSlicesApiEnabledFieldsFragment>;

  /**
   * __useSiteDetailsGatsbyjsioEnabledFieldsFragment__
   * To read a fragment data from Apollo Cache, call `useSiteDetailsGatsbyjsioEnabledFieldsFragment` and pass it the ID of the cached object.
   * When your component renders, `useSiteDetailsGatsbyjsioEnabledFieldsFragment` returns an object from Apollo Client cache that contains data property
   * you can use to render your UI.
   *
   * @param id a string representing the ID of the cached object that will be passed into the useApolloFragment
   *
   * @example
   * const { data } = useSiteDetailsGatsbyjsioEnabledFieldsFragment('fragment-id');
   */
export function useSiteDetailsGatsbyjsioEnabledFieldsFragment(id: string) {
          return useApolloFragment<SiteDetailsGatsbyjsioEnabledFieldsFragment>(SiteDetailsGatsbyjsioEnabledFieldsFragmentDoc, id);
        }
export type SiteDetailsGatsbyjsioEnabledFieldsFragmentHookResult = ReturnType<typeof useSiteDetailsGatsbyjsioEnabledFieldsFragment>;

  /**
   * __useSiteDetailsPreviewBuildsEnabledFieldsFragment__
   * To read a fragment data from Apollo Cache, call `useSiteDetailsPreviewBuildsEnabledFieldsFragment` and pass it the ID of the cached object.
   * When your component renders, `useSiteDetailsPreviewBuildsEnabledFieldsFragment` returns an object from Apollo Client cache that contains data property
   * you can use to render your UI.
   *
   * @param id a string representing the ID of the cached object that will be passed into the useApolloFragment
   *
   * @example
   * const { data } = useSiteDetailsPreviewBuildsEnabledFieldsFragment('fragment-id');
   */
export function useSiteDetailsPreviewBuildsEnabledFieldsFragment(id: string) {
          return useApolloFragment<SiteDetailsPreviewBuildsEnabledFieldsFragment>(SiteDetailsPreviewBuildsEnabledFieldsFragmentDoc, id);
        }
export type SiteDetailsPreviewBuildsEnabledFieldsFragmentHookResult = ReturnType<typeof useSiteDetailsPreviewBuildsEnabledFieldsFragment>;

  /**
   * __useSitePreviewSettingsFieldsFragment__
   * To read a fragment data from Apollo Cache, call `useSitePreviewSettingsFieldsFragment` and pass it the ID of the cached object.
   * When your component renders, `useSitePreviewSettingsFieldsFragment` returns an object from Apollo Client cache that contains data property
   * you can use to render your UI.
   *
   * @param id a string representing the ID of the cached object that will be passed into the useApolloFragment
   *
   * @example
   * const { data } = useSitePreviewSettingsFieldsFragment('fragment-id');
   */
export function useSitePreviewSettingsFieldsFragment(id: string) {
          return useApolloFragment<SitePreviewSettingsFieldsFragment>(SitePreviewSettingsFieldsFragmentDoc, id);
        }
export type SitePreviewSettingsFieldsFragmentHookResult = ReturnType<typeof useSitePreviewSettingsFieldsFragment>;

  /**
   * __useSiteDetailsManualHostingDeploysEnabledFieldsFragment__
   * To read a fragment data from Apollo Cache, call `useSiteDetailsManualHostingDeploysEnabledFieldsFragment` and pass it the ID of the cached object.
   * When your component renders, `useSiteDetailsManualHostingDeploysEnabledFieldsFragment` returns an object from Apollo Client cache that contains data property
   * you can use to render your UI.
   *
   * @param id a string representing the ID of the cached object that will be passed into the useApolloFragment
   *
   * @example
   * const { data } = useSiteDetailsManualHostingDeploysEnabledFieldsFragment('fragment-id');
   */
export function useSiteDetailsManualHostingDeploysEnabledFieldsFragment(id: string) {
          return useApolloFragment<SiteDetailsManualHostingDeploysEnabledFieldsFragment>(SiteDetailsManualHostingDeploysEnabledFieldsFragmentDoc, id);
        }
export type SiteDetailsManualHostingDeploysEnabledFieldsFragmentHookResult = ReturnType<typeof useSiteDetailsManualHostingDeploysEnabledFieldsFragment>;

  /**
   * __useSiteDetailsMerlinPullRequestsSourcingEnabledFieldsFragment__
   * To read a fragment data from Apollo Cache, call `useSiteDetailsMerlinPullRequestsSourcingEnabledFieldsFragment` and pass it the ID of the cached object.
   * When your component renders, `useSiteDetailsMerlinPullRequestsSourcingEnabledFieldsFragment` returns an object from Apollo Client cache that contains data property
   * you can use to render your UI.
   *
   * @param id a string representing the ID of the cached object that will be passed into the useApolloFragment
   *
   * @example
   * const { data } = useSiteDetailsMerlinPullRequestsSourcingEnabledFieldsFragment('fragment-id');
   */
export function useSiteDetailsMerlinPullRequestsSourcingEnabledFieldsFragment(id: string) {
          return useApolloFragment<SiteDetailsMerlinPullRequestsSourcingEnabledFieldsFragment>(SiteDetailsMerlinPullRequestsSourcingEnabledFieldsFragmentDoc, id);
        }
export type SiteDetailsMerlinPullRequestsSourcingEnabledFieldsFragmentHookResult = ReturnType<typeof useSiteDetailsMerlinPullRequestsSourcingEnabledFieldsFragment>;